import React, {useEffect, useState} from "react";
import { Redirect, Route } from "react-router-dom"; // Importe o Redirect e Route
import {Grid, Row, Col} from "react-bootstrap";
import Slider from "react-slick";
import Proof from "../../components/Proof/Proof.jsx";
import ProofEvaluative from "../../components/Proof/ProofEvaluative.jsx";
import {Scorm} from "../../components/Course/Scorm.jsx";
import {SidebarCourse} from "../../components/Sidebar/SidebarCourse.jsx";
import {CourseCarousel} from "../../components/CoursePage/CourseCarousel.jsx";
import TrailCarousel from "../../components/CoursePage/TrailCarousel.jsx";
import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";

import Config from "../../config/config";
import AccountService from "../../services/AccountService";
import DamService from "../../services/DamService";
import LmsService from "../../services/LmsService";
import Spinner from "../../components/Spinner";
import Player from "../../components/Player/Player";
import {ApolloClient} from "apollo-client";
import gql from "graphql-tag";
import HttpLinkServices from "../../services/HttpLinkServices";
import {InMemoryCache} from "apollo-cache-inmemory";
import { useCompletedItemsOnTheTrail } from "../../hooks/CompletedItemsOnTheTrail";
import { formattedCurrentDate } from "../../utils/dateFormat";
import thumb_asset from "../../assets/img/thumb-assets.png";
import {FaCloudDownloadAlt} from "react-icons/fa";

const resizeIframe = (counter = 0)=>{
  const obj = document.getElementById('embeded-scorm');

  if(obj.contentWindow.document.documentElement.scrollHeight >=1200){
    obj.parentNode.style.minHeight = null;
    return;
  }

  obj.parentNode.style.minHeight = obj.contentWindow.document.documentElement.scrollHeight;

  if(counter < 10){
    setTimeout(() => {
      resizeIframe(counter + 1);
    }, 1000);
  }
}

const CoursePage = ({match}) => {
  const {id, type, trail_id} = match.params;
  const accountServices = new AccountService();
  const damServices = new DamService();
  const lmsService = new LmsService();
  const lms_client = new ApolloClient({
    link: HttpLinkServices.lms,
    cache: new InMemoryCache(),
  });

  const [trailTitle, setTrailTitle] = useState();
  const [courseFinish, setCourseFinish] = useState(false);
  const [videoWasWatched, setVideoWasWatched] = useState(false);
  const [authenticatedUser, setAuthenticatedUser] = useState({});
  const [asset, setAsset] = useState({});
  const [course, setCourse] = useState({});
  const [cursosMaisAssistidos, setCursosMaisAssistidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const { loadCompletedItemsOnTrail } = useCompletedItemsOnTheTrail();
  const [redirectToInativeCourse, setRedirectToInativeCourse] = useState(false);
  const [redirectToInativeTrail, setRedirectToInativeTrail] = useState(false);


  const handleViewed = async (item_id, item_type, item_title, course_video) => {

    const userResponse = await accountServices.getAuthenticatedUser();
    const user = userResponse.data.get_authenticated_user;

    if(trail_id) {

      const response = await lmsService.getTrailItemHasUser(trail_id);
      let completedItemsOnTrail = response.data.trail_itens_by_user.trailitenshasuser;

      const trailResponse = await lmsService.getTrail(trail_id);
      const trail = trailResponse.data.trail;

      const trailItemsResponse = await lmsService.getTrailItems(trail_id);
      const trailItems = trailItemsResponse.data.trailitems.trailitems;

      let category;
      const categoryHasTrailResponse = await lmsService.getCategoryHasTrail(trail_id);
      const categoryHasTaril = categoryHasTrailResponse.data.categoryHasTrail_collection.category_has_trail;
      if(categoryHasTaril.length > 0) {
        const categoryResponse = await damServices.getGategory(categoryHasTaril[0].category_id);
        category = categoryResponse.data.category;
      }

      /**
       * Preenchendo o objeto customData
       */
      window.customData.curso.produto = category.title;
      window.customData.curso.item.indice = trailItems.findIndex((item) => item.item_id === item_id ) + 1;

      const trailGTMresponse = await lmsService.getTrailGTM(trail_id, item_id);

      // Constante criada para auxiliar no controle dos eventos
      const savedItem = trailGTMresponse.data.trailGTM;

      loadCompletedItemsOnTrail(completedItemsOnTrail);


      if(completedItemsOnTrail.length < 1) {
          // Google Tag Manager
          addToDataLayerGTM({
            'event' : 'solicitacao_servico',
            'nome_servico' : 'iniciar-trilha',
            'id_solicitacao' : user.id,
            'nome_curso' : item_title,
            'data_servico' : formattedCurrentDate(),
            'produto' : category ? category.title : '',
            'brand' : 'porto seguro',
            'retorno' : 'sucesso',
            'descricao' : 'etapa desbloqueada'
          });
      }

      const checkItemAlreadyCompleted = completedItemsOnTrail.find(item => item.item_id === item_id);


      if (!checkItemAlreadyCompleted && completedItemsOnTrail.length > 0 && !savedItem) {
        // Google Tag Manager
        addToDataLayerGTM({
          'event' : 'solicitacao_servico',
          'nome_servico' : 'desbloqueio-etapa',
          'id_solicitacao' : user.id,
          'nome_curso' : item_title,
          'data_servico' : formattedCurrentDate(),
          'produto' : category ? category.title : '',
          'brand' : 'porto seguro',
          'retorno' : 'sucesso',
          'descricao' : 'etapa desbloqueada'
        });
      }

      // Caso o ítem seja um curso e possua vídeo, só será salvo no banco se o usuário tiver assistido 70% do vídeo ou mais.
      if(item_type === "course" && course_video && course_video.id) {
        const response = await lmsService.getUserHasVideo(item_id);
        const { user_has_video } = response.data;

        if(!user_has_video) {
          return !savedItem && await lmsService.createTrailGTM(trail_id, item_id);
        }
      }

      if (trail.proof && trail.proof.id && !checkItemAlreadyCompleted && completedItemsOnTrail.length === (trailItems.length - 1) ) {
        addToDataLayerGTM({
          'event' : 'solicitacao_servico',
          'nome_servico' : 'desbloqueio-etapa',
          'id_solicitacao' : user.id,
          'nome_curso' : 'Avaliação de aprendizagem',
          'data_servico' : formattedCurrentDate(),
          'produto' : category ? category.title : '',
          'brand' : 'porto seguro',
          'retorno' : 'sucesso',
          'descricao' : 'etapa desbloqueada'
        });
      }

      await lmsService.saveTrailItemHasUser({
        trail_id,
        item_id,
        item_type
      });

      !savedItem && await lmsService.createTrailGTM(trail_id, item_id);

      const newItem = {
        item_id,
        item_type
      }

      if(!checkItemAlreadyCompleted) {
        completedItemsOnTrail = [...completedItemsOnTrail, newItem];
      }

      loadCompletedItemsOnTrail(completedItemsOnTrail);

    } else {

      let category;
      const categoryHasCourseResponse = await lmsService.getCategoryHasCourse(item_id);
      const categoryHasCourse = categoryHasCourseResponse.data.categoryHasCourse_collection.category_has_course;

      const courseResponse = await lmsService.getCourse(item_id);
      const { course } = courseResponse.data;


      if(categoryHasCourse.length > 0) {
        const categoryResponse = await damServices.getGategory(categoryHasCourse[0].category_id);
        category = categoryResponse.data.category;
      }

      // Preenchendo o objeto customData
      window.customData.curso.produto = category.title;

      const courseGTMresponse = await lmsService.getCourseGTM(item_id, item_id);
      const savedItem = courseGTMresponse.data.courseGTM;

      if(course_video) {// Se o curso for um vídeo

        const response = await lmsService.getUserHasVideo(item_id);
        const { user_has_video } = response.data;

        if(!user_has_video) {

          return addToDataLayerGTM({
            'event' : 'solicitacao_servico',
            'nome_servico' : 'iniciar-curso',
            'id_solicitacao' : user.id,
            'nome_curso' : item_title,
            'data_servico' : formattedCurrentDate(),
            'produto' : category ? category.title : '',
            'brand' : 'porto seguro',
            'retorno' : 'sucesso',
            'descricao' : 'etapa desbloqueada'
          });
        }

        if(!savedItem && course.proof && course.proof.id) {
            addToDataLayerGTM({
            'event' : 'solicitacao_servico',
            'nome_servico' : 'desbloqueio-etapa',
            'id_solicitacao' : user.id,
            'nome_curso' : 'Avaliação de aprendizagem',
            'data_servico' : formattedCurrentDate(),
            'produto' : category ? category.title : '',
            'brand' : 'porto seguro',
            'retorno' : 'sucesso',
            'descricao' : 'etapa desbloqueada'
          });
        }

        !savedItem && await lmsService.createCourseGTM(item_id, item_id);
      } else {// se o curso for um scorm

        if(!savedItem) {
          addToDataLayerGTM({
            'event' : 'solicitacao_servico',
            'nome_servico' : 'iniciar-curso',
            'id_solicitacao' : user.id,
            'nome_curso' : item_title,
            'data_servico' : formattedCurrentDate(),
            'produto' : category ? category.title : '',
            'brand' : 'porto seguro',
            'retorno' : 'sucesso',
            'descricao' : 'etapa desbloqueada'
          });

          if(course.proof && course.proof.id) {
            addToDataLayerGTM({
            'event' : 'solicitacao_servico',
            'nome_servico' : 'desbloqueio-etapa',
            'id_solicitacao' : user.id,
            'nome_curso' : 'Avaliação de aprendizagem',
            'data_servico' : formattedCurrentDate(),
            'produto' : category ? category.title : '',
            'brand' : 'porto seguro',
            'retorno' : 'sucesso',
            'descricao' : 'etapa desbloqueada'
            });
          }
          await lmsService.createCourseGTM(item_id, item_id);
        }

      }

    }
  }

  const getVideoUrl = (course) => {
    let iframeUrl = ""

    if (course.code && course.code.indexOf("[h5") === 0) {
      const lenCode = (course.code.length - 11);
      const codeCourse = course.code.substr(course.code.indexOf('="') + 2, lenCode);
      iframeUrl = "https://pluz.io/porto-seguro/wp-admin/admin-ajax.php?action=h5p_embed&id=" + codeCourse;
    }

    setIframeUrl(iframeUrl);
  }

  
  const checkURL = async () => {
    const currentURL = window.location.href;
    if (currentURL.match(/\/trail\/\d+\/\w+\/\d+/)) {
      try {
        const response = await lmsService.getTrail(trail_id);
        const { trail } = response.data;
        const { active } = trail;
        if (!active) {
          window.location.href = `${Config.baseUrl}/api/v1/lms/inative-trail`;
        }
      } catch (error) {
        console.error("Erro ao buscar o status 'active' da trilha:", error);
      }
    } else if (currentURL.match(/\/curso\/\d+/)) {
      try {
        const response = await lmsService.getCourse(id);
        const { course } = response.data;
        const { active } = course;
        if (!active) {
          window.location.href = `${Config.baseUrl}/api/v1/lms/inative-course`;
        }
      } catch (error) {
        console.error("Erro ao buscar o status 'active' do curso:", error);
      }
    }
  };
  

  useEffect(() => {
    checkURL();
    window.scroll(0, 0);
    async function getAuthenticatedUser() {
      try {
        const response = await accountServices.getAuthenticatedUser();
        setAuthenticatedUser(response.data.get_authenticated_user);
      } catch (error) {
        // Google Tag Manager
        addToDataLayerGTM({
          'event': 'erro',
          'descricao': 'erro ao buscar o usuário autenticado.'
        });
      }
    }

    async function getMaisAssistidos() {
      lms_client
          .query({
            query: gql`
              query getCursos {
                  courses_collections(limit: 8) {
                    courses{
                    id,title,thumbnail
                    }
                }
              }
            `
          }).then(result => setCursosMaisAssistidos(result.data.courses_collections.courses));
    }

    if(trail_id) {

      async function getTrail(){
        const response = await lmsService.getTrail(trail_id);
        setTrailTitle(response.data.trail.title);

        //Preenchendo objeto customData
        window.customData.curso.nome = response.data.trail.title;
      }

      /**
       * Atualiza o valor do estado global dos itens concluídos na trilha caso
       * esse ítem seja uma avaliação de aprendizagem ou pesquisa NPS.
       */
      if(type === "proof" || type === "reactionevaluation")  {
       lmsService.getTrailItemHasUser(trail_id).then(response => {
         loadCompletedItemsOnTrail(response.data.trail_itens_by_user.trailitenshasuser);
       });
      }

      getTrail();
    }

    getAuthenticatedUser();
    getMaisAssistidos();

  }, []);

  useEffect(() => {

    async function getCourseData() {
      setLoading(true);
      if (type === "asset") {
        try {
          const response = await damServices.getAsset(id);

          setAsset(response.data.asset);
          handleViewed(response.data.asset.id, "asset", response.data.asset.title);
          if (trail_id) {
            addToDataLayerGTM({
              'event': 'step_change',
              'etapa': `/trilhas/${response.data.asset.title}`,
            });

            window.customData.curso = {
              ...window.customData.curso,
              etapa: response.data.asset.title,
              brand: 'porto-seguro',
              tipo: 'trilha',
              item: {
                nome: response.data.asset.title,
              },
            }
          } else {
            addToDataLayerGTM({
              'event': 'step_change',
              'etapa': `/cursos/${response.data.asset.title}`,
            });

            window.customData.curso = {
              nome: response.data.asset.title,
              etapa: response.data.asset.title,
              tipo: 'asset',
              brand: 'porto-seguro',
              tempo: '',
              curtido: '',
              favorito: '',
              indice : 1,
            }
          }

        } catch (error) {
          // Google Tag Manager
          addToDataLayerGTM({
            'event': 'erro',
            'descricao': 'erro ao buscar os assets'
          });
        }
      } else if (type !== "proof" && type !== "reactionevaluation") {

        // Se item da Trilha for Course ou se a tela for Course
        try {
          const response = await lmsService.getCourse(id);
          setCourse(response.data.course);
          getVideoUrl(response.data.course);
          handleViewed(response.data.course.id, "course", response.data.course.title, response.data.course.video);
          window.customData.curso.etapa = response.data.course.title;

          if (typeof response.data.course.video != 'undefined' && response.data.course.video != null) {
            lmsService.saveVideoHasUser({
              video_id: response.data.course.video.id,
              defaultProject: true
            });
          }
          // Google Tag Manager
          if (trail_id) {

            addToDataLayerGTM({
              'event': 'step_change',
              'etapa': `/trilhas/${response.data.course.title}`,
            });

            window.customData.curso = {
              ...window.customData.curso,
              tipo: 'trilha',
              brand: 'porto-seguro',
              item: {
                name: response.data.course.title,
                favorito: '',
                curtido: '',
                tempo: '',
              },
              modulos: '',
            }
          } else {
            if(match.path === '/curso/:id') {
              addToDataLayerGTM({
                'event': 'step_change',
                'etapa': `cursos/online/${response.data.course.title}`,
              });
              window.customData.curso = {
                nome: response.data.course.title,
                etapa: response.data.course.title,
                tipo: response.data.course.type,
                brand: 'porto-seguro',
                tempo: response.data.course.minutes,
                curtido: '',
                favorito: '',
                indice: 1,
              };
            }

          }

        } catch (error) {
          // Google Tag Manager
          addToDataLayerGTM({
            'event': 'erro',
            'descricao': 'erro ao buscar os cursos'
          });
        }
      }
      setLoading(false);
    }

    getCourseData();
  }, [type, id]);

  useEffect(() => {
    return () => window.customData.curso = {};
  },[]);

  async function checkViewOnVideo (eventData) {
    if(typeof this.secsExec === "undefined") {
      this.secsExec = [];
    }
    if(typeof this.confirmView === "undefined") {
      this.confirmView = false;
    }
    if(eventData.duration && eventData.duration > 0 && eventData.event == "onListen"){
      var currentSecVideo = Math.floor(eventData.eventParam);
      if(!this.secsExec.includes(currentSecVideo)) {
        this.secsExec.push(currentSecVideo);
        var secsExecCount = this.secsExec.length;
        var totalSecs = eventData.duration/1000;
        if(secsExecCount/totalSecs >= 0.7 && !this.confirmView){
          this.confirmView = true;
          // Definir o vídeo como visto, após 70% de visualização
          await lmsService.saveVideoHasUserFinish({
            video_id: course.video.id
          });

          await handleViewed(course.id, "course", course.title, course.video);

          !trail_id && setVideoWasWatched(true);
        }
      }
    }
  }

  return (
    <div id="CoursePage">
      <Grid>
        <div className="course_sidebar">
          { // Se não tiver a trilha, exibe as avaliações do curso
            !trail_id && id &&
            <CourseCarousel
              courseFinish={courseFinish}
              videoWasWatched={videoWasWatched}
              course_id={id}
              course_proof_type={match.params.course_proof_type ? match.params.course_proof_type : false}
            />
          }
          { // Só exibe a trilha se tiver o param do ID da trilha na URL
            trail_id &&
            <TrailCarousel
              courseFinish={courseFinish}
              trail_id={trail_id}
              item_id={id}
              item_type={type}
            />
          }
        </div>

        <div className="course_content">

          {loading ? (
            <div className="loadingContainer">
              <Spinner/>
            </div>
          ) : (
            ((type === "reactionevaluation" || type === "proof")) ?

                <div className="content">
                  <Grid fluid>
                    <Row>
                      <Col md={12}>
                        <div>
                          {type === "proof"
                            ?
                            <ProofEvaluative
                              item_id={trail_id}
                              item_type="trail"
                              item_title={trailTitle}
                              setCourseFinish={setCourseFinish}
                              proof_id={id}
                            />
                            :
                            <Proof
                              item_id={trail_id}
                              item_type="trail"
                              proof_id={id}
                            />
                          }
                        </div>
                      </Col>
                    </Row>

                </Grid>
              </div> : <div>
                {type === "asset" ?
                  <div>
                    <div className="content">
                      <Grid fluid>
                        <Row>
                          <Col md={12}>
                            <div>

                              <div className="download_asset_big">
                                <a href={Config.baseUrl + "/dam/assets/" + asset.asset} download target="_blank">
                                  <div class="course-item-download-view">
                                    <FaCloudDownloadAlt class={"icon-play"} size={120} color={"white"}/>
                                  </div>
                                  <img src={thumb_asset}/>
                                </a>
                              </div>

                                <h1>{asset.title}</h1>
                              </div>
                            </Col>
                          </Row>
                        </Grid>
                      </div>
                    </div>
                    :
                    <div>
                      <div className="content content-scorm">
                        <Grid fluid>
                          <Row>
                            <Col md={12}>
                              <div>
                                {match.params.course_proof_id
                                  ?
                                  <div>
                                    {match.params.course_proof_type === "proof"
                                      ?
                                      <ProofEvaluative
                                        item_id={course.id}
                                        item_title={course.title}
                                        user_id={authenticatedUser.id}
                                        item_type="course"
                                        setCourseFinish={setCourseFinish}
                                        proof_id={match.params.course_proof_id}
                                      />
                                      :
                                      <Proof
                                        item_id={course.id}
                                        item_type="course"
                                        proof_id={match.params.course_proof_id}
                                        authenticatedUserToken={authenticatedUser.token}
                                      />
                                    }
                                  </div>

                                :
                                <div>
                                  {course && course.scorm && authenticatedUser ?
                                    <Scorm course={course} user={authenticatedUser}/>
                                    :
                                      <div className="embed-responsive embed-responsive-16by9 card shadow-sm">
                                        {iframeUrl != '' ? (
                                          <iframe
                                            className="embed-responsive-item"
                                            id="embeded-scorm"
                                            allowFullScreen
                                            webkitallowfullscreen="true"
                                            mozallowfullscreen="true"
                                            src={iframeUrl}
                                            scrolling="no"
                                            frameBorder="0"
                                            allow="geolocation; microphone; camera; encrypted-media; midi"
                                            data-gtm-type="click"
                                            data-gtm-clicktype="video"
                                            data-gtm-name={course.title}
                                            onLoad={function(){resizeIframe()}}
                                            />
                                        ) : (
                                            <Player
                                                video_id={course.video ? course.video.id : ''}
                                                onListen={checkViewOnVideo}
                                            />
                                        )}
                                      </div>
                                  }
                                </div>
                              }
                              {course &&
                                <div>
                                  <h1>{course.title}</h1>
                                  <p>{course.description}</p>
                                </div>
                              }
                            </div>
                          </Col>
                        </Row>

                        {type !== "proof" && course && (
                          <Row>
                            <Col md={12}>
                              <SidebarCourse isTrail={trail_id} course={course}/>
                            </Col>
                          </Row>
                      )}

                      </Grid>
                    </div>
                  </div>

                }
              </div>
          )}

        </div>
      </Grid>

      <div className="both"/>

      {cursosMaisAssistidos.length > 0 &&
      <div className="content content_bar">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <h2>
                Mais assistidos
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Slider
                  {
                    ...{
                      autoplay: false,
                      dots: false,
                      infinite: true,
                      speed: 500,
                      slidesToShow: (window.innerWidth <= 987 ? 2 : 4),
                      slidesToScroll: (window.innerWidth <= 987 ? 2 : 4)
                    }
                  }>
                {cursosMaisAssistidos.map((item) => (
                    <div key={item.id} className="course-item">
                      <a
                          data-gtm-type="click"
                          data-gtm-clicktype="card"
                          data-gtm-name={item.title}
                          href={"/#/curso/" + item.id}>
                        <img src={Config.baseUrl + "/lms/assets/" + item.thumbnail}/>
                        <div className="title">{item.title}</div>
                      </a>
                    </div>
                ))}
              </Slider>
            </Col>
          </Row>
        </Grid>
      </div>
      }
    </div>
  )
};

export default CoursePage;



// WEBPACK FOOTER //
// ./src/views/CoursePage/CoursePage.jsx